export default __webpack_public_path__ + "static/hero-koi-computers-2-728252fe7687e699576ede8379677d6f.png";